import qs from 'qs';
import { getCurrentUser } from 'src/utils/local';
import { ROLES } from '../utils/constant';

import { hopliteAxios } from './axios';

export const uploadFile = async (file: File) => {
  if (!file) return null;
  const formData = new FormData();
  formData.append('file', file);
  return await hopliteAxios('POST', '/chatbot-upload', formData);
};

export const addMission = async (mission: Record<string, unknown>) => {
  return await hopliteAxios('POST', '/chatbot-add-mission', mission, true);
};

export const editMission = async (mission: Record<string, unknown>) => {
  return await hopliteAxios('POST', '/chatbot-set-mission', mission, true);
};

export const getMissionReport = async (id: string) => {
  return await hopliteAxios('POST', '/chatbot-get-mission-report', { id }, true);
};

export const approveSubmissions = async (ids: string[]) => {
  return await hopliteAxios('POST', '/chatbot-approve-submissions', { ids }, true);
};

export const getAllUsers = async () => {
  return await hopliteAxios('POST', '/chatbot-get-user', qs.stringify({ email: 'all' }));
};

export const getUser = async (data: Record<string, unknown>) => {
  return await hopliteAxios('POST', '/chatbot-get-user', qs.stringify(data));
};

export const getAllCompanies = async () => {
  const user = getCurrentUser();
  let data = {};
  if (user?.role !== ROLES.platformAdmin) data = { cid: user.company_id };
  return await hopliteAxios('POST', '/chatbot-get-company', qs.stringify(data));
};

export const getCompany = async (companyId: string = '') => {
  if (companyId) return await hopliteAxios('POST', '/chatbot-get-company', qs.stringify({ cid: companyId }));
  return await hopliteAxios('POST', '/chatbot-get-company', '');
};

export const getCourse2User = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-get-course2user', qs.stringify(data));
};

export const getCourse = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-get-course', qs.stringify(data));
};

export const getAllCourses = async () => {
  return await hopliteAxios('POST', '/chatbot-get-course', qs.stringify({ courseid: 'all' }));
};

export const getLogin = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-get-login', qs.stringify(data));
};

export const resetLogin = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-reset-login', qs.stringify(data), true);
};

export const getLoginsHistory = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-get-loginsHistory', qs.stringify(data));
};

export const addUser = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-add-user', qs.stringify(data));
};

export const addLogin = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-add-login', qs.stringify(data));
};

export const editUserData = async (data: object) => {
  // edit user
  return await hopliteAxios('POST', '/chatbot-set-user', qs.stringify(data));
};

export const editRoleDepartment = async (data: object) => {
  // email: required, role and department: optional
  return await hopliteAxios('POST', '/chatbot-set-role-department', qs.stringify(data));
};

export const deleteTrainee = async (data: object) => {
  // email: required
  return await hopliteAxios('POST', '/chatbot-delete-trainee', qs.stringify(data));
};

export const deleteDepartment = async (data: string) => {
  // email: required
  return await hopliteAxios('POST', '/chatbot-delete-department-admin', data);
};

export const inactiveTrainee = async (data: string) => {
  // email: required
  return await hopliteAxios('POST', '/chatbot-inactive-trainee', data);
};

export const inactiveDepartmentAdmin = async (data: string) => {
  // email: required
  return await hopliteAxios('POST', '/chatbot-inactive-department-admin', data);
};

export const inactiveUser = async (data: object) => {
  // email: required
  return await hopliteAxios('POST', '/chatbot-inactive-user', qs.stringify(data), true);
};

export const activeUser = async (data: object) => {
  // email: required
  return await hopliteAxios('POST', '/chatbot-active-user', qs.stringify(data), true);
};

export const deleteUser = async (uid: string) => {
  return await hopliteAxios('POST', '/chatbot-delete-user', qs.stringify({ uid }), true);
};

export const checkInactive = async () => {
  return await hopliteAxios('POST', '/chatbot-check-inactive', '');
};

export const exportResults = async (data: string) => {
  return await hopliteAxios('POST', '/chatbot-export-results', data, true);
};

export const sendCourseReminderEmail = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-send-email-course-remind', qs.stringify(data), true);
};

export const getMissions = async () => {
  return await hopliteAxios('POST', '/chatbot-get-mission', '', true);
};

export const addSubmission = async (data: object) => {
  return await hopliteAxios('POST', '/chatbot-add-submission', data, true);
};

export const getMyCourse = async () => {
  return await hopliteAxios('POST', '/chatbot-get-my-course', '', true);
};

export const getMyMission = async () => {
  return await hopliteAxios('POST', '/chatbot-get-my-mission', '', true);
};

export const getMyResult = async () => {
  return await hopliteAxios('POST', '/chatbot-get-my-result', '', true);
};
